export const ButtonSpinnerDimension = {
    large: 24,
    medium: 20,
    small: 16,
}
export const ButtonSpinnerMargin = 8;